<template>
    <div :class="isMobile ? 'text-center' : ''" class="position-relative">
        <SelectFileSizeDropdown
            v-if="isMobile"
            :is-day-billing-selected="isDayBillingSelected"
            :selectable-sizes="selectableSizes"
            :disabled="disabled"
            v-model="selectedSize"
        >
            <template v-slot:labelText>
                {{ 'Total file size per conversion' | trans }}
                <Tooltip position="bottom">
                    <template v-slot:icon><i class="fa fa-question-circle text-info cursor-pointer"></i></template>
                    <template v-slot:tooltip-content> {{ tooltipText }}</template> </Tooltip
                >:
                <br />
            </template>
        </SelectFileSizeDropdown>

        <SelectFileSizeSlider
            v-else-if="!isMobile"
            :is-day-billing-selected="isDayBillingSelected"
            :selectable-sizes="selectableSizes"
            :disabled="disabled"
            v-model="selectedSize"
        >
            <template v-slot:labelText>
                {{ 'Total file size per conversion' | trans }}
                <Tooltip position="bottom">
                    <template v-slot:icon><i class="fa fa-question-circle text-info cursor-pointer"></i></template>
                    <template v-slot:tooltip-content> {{ tooltipText }}</template> </Tooltip
                >:
            </template>
        </SelectFileSizeSlider>
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/default.css';
import SelectFileSizeDropdown from './SelectFileSizeDropdown';
import SelectFileSizeSlider from './SelectFileSizeSlider';
import { translate } from '../../../../../qaamgo/helper/translate';
import { pageStoreMixin } from '../../../../store/page-store';
import Tooltip from '../../../../../qaamgo/modules/sat/components/form/Tooltip';
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { LIMITS_ORIGIN_UPLOADER_EVENT } from '../../../../store/modules/limits-store';
import { LIMIT_INPUT_TOO_LARGE } from '../../../../limits/limits';

export default {
    name: 'SelectFileSize',
    components: { Tooltip, SelectFileSizeSlider, SelectFileSizeDropdown, VueSlider },
    mixins: [TransFilter, pageStoreMixin],
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    beforeMount() {
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);

        this.selectableSizes = this.getSelectableSizes();

        this.tooltipText = translate(
            'The maximum size of a file that can be converted in one conversion. If you convert several files in one conversion (batch conversion), this limit is the sum of all file sizes. Of course you can start many conversions.'
        );

        if (testIsNonEmptyString(this.selectedSizeStore)) {
            this.selectedSize = this.selectedSizeStore;
        }

        const sizeInt = Number.parseInt(this.selectedSize);
        if (this.isDayBillingSelected && sizeInt < 1000) {
            this.selectedSize = '1000';
        }

        //When the modal is opened because a limit is hit,
        //we want to preselect the needed minimum filesize for the plan
        //the user needs
        if (this.currentLimits.length > 0) {
            this.setMinimumFileSizeNeeded();
        }
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    watch: {
        selectedSize(size) {
            this.store.userPaymentModal.setSelectedSize(size);
        },
        selectedSizeStore(size) {
            if (this.selectedSize !== size) {
                this.selectedSize = size;
            }
        },
    },
    computed: {
        selectedSizeStore() {
            return this.store.userPaymentModal.selectedSize;
        },
        selectedBilling() {
            return this.store.userPaymentModal.selectedBilling;
        },
        isDayBillingSelected() {
            return this.selectedBilling === 'day';
        },
        currentLimits() {
            return this.store.limits.getLimits;
        },
    },
    methods: {
        getSelectableSizes() {
            return {
                200: translate('%1 MB', { '%1': '200' }),
                400: translate('%1 MB', { '%1': '400' }),
                1000: translate('%1 GB', { '%1': '1' }),
                2000: translate('%1 GB', { '%1': '2' }),
                4000: translate('%1 GB', { '%1': '4' }),
                8000: translate('%1 GB', { '%1': '8' }),
            };
        },
        getMinimumFileSizeNeeded(fileSize) {
            //if the file size is bigger then the biggest size we offer, we preselect the default value
            if (fileSize > this.selectableSizesMB.slice(-1)) {
                return '200';
            }

            return this.selectableSizesMB.find((selectableSize) => parseInt(selectableSize) >= fileSize);
        },
        setMinimumFileSizeNeeded() {
            for (const limit of this.currentLimits) {
                if (limit.origin === LIMITS_ORIGIN_UPLOADER_EVENT && limit.limits[0].type === LIMIT_INPUT_TOO_LARGE) {
                    //convert from bytes to MB
                    const fileSize = limit.limits[0].currentValue / 1000000;
                    this.selectedSize = this.getMinimumFileSizeNeeded(fileSize);
                }
            }
        },
        checkIfMobile() {
            this.isMobile = window.matchMedia('(max-width: 500px)').matches;
        },
    },
    data() {
        return {
            selectedSize: '200',
            selectableSizes: {},
            isMobile: false,
            tooltipText: '',
            selectableSizesMB: ['200', '400', '1000', '2000', '4000', '8000'],
        };
    },
};
</script>

<style>
.select-file-size-learn-more-box {
    top: 100%;
    max-width: 325px;
    z-index: 10;
}
</style>
